import { useTranslation } from 'react-i18next';

export default function Dashboard1({ summary }) {
    const { t } = useTranslation();

    const list = [
        {
            title: 'Personal Data',
            total: summary?.personalDataTotal,
            description: t('Personal data that the organization collects'),
            color: '#1890FF',
            key: 'personal',
        },
        {
            title: 'Sensitive Data',
            total: summary?.personalDataSensitiveTotal,
            description: t('Sensitive data that the organization collects'),
            color: '#FFA800',
            key: 'sensitive',
        },
    ];

    return (
        <div className="grid grid-rows-2 gap-4 h-full">
            {list.map((item) => (
                <div
                    key={item.key}
                    className="bg-white rounded-md flex pr-4 items-center h-full"
                >
                    <div
                        className="h-52 w-2 rounded-r-md"
                        style={{ background: item.color }}
                    ></div>
                    <div className="ml-4">
                        <div className="font-semibold text-[60px]">{item.total}</div>
                        <div className="text-gray-600 font-semibold text-xl">
                            {item.title}
                        </div>
                        <div className="text-gray-500">{item.description}</div>
                    </div>
                    <div className="ml-auto">{Icon[item.key]}</div>
                </div>
            ))}
        </div>
    );
}

const Icon = {
    personal: (
        <svg
            width={100}
            height={101}
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx={50} cy="50.25" r={50} fill="#DFF0FF" />
            <g clipPath="url(#clip0_678_65350)">
                <path
                    d="M50.0028 50.3586C55.9553 50.3586 60.8211 45.4928 60.8211 39.5404C60.8211 33.588 55.9553 28.7222 50.0028 28.7222C44.0504 28.7222 39.1847 33.588 39.1847 39.5404C39.1847 45.4928 44.0505 50.3586 50.0028 50.3586Z"
                    fill="#1890FF"
                />
                <path
                    d="M68.5687 59.0038C68.2852 58.2952 67.9073 57.6338 67.4822 57.0197C65.3091 53.8072 61.955 51.6814 58.1757 51.1617C57.7033 51.1145 57.1837 51.2089 56.8057 51.4924C54.8216 52.9569 52.4596 53.7127 50.003 53.7127C47.5464 53.7127 45.1844 52.9569 43.2002 51.4924C42.8223 51.2089 42.3026 51.0672 41.8302 51.1617C38.0509 51.6814 34.6496 53.8072 32.5238 57.0197C32.0986 57.6338 31.7206 58.3424 31.4372 59.0038C31.2956 59.2873 31.3428 59.6179 31.4844 59.9014C31.8624 60.5628 32.3348 61.2242 32.7599 61.7911C33.4213 62.6887 34.1299 63.4917 34.9331 64.2476C35.5944 64.9089 36.3503 65.5231 37.1062 66.1372C40.8382 68.9245 45.3261 70.3889 49.9558 70.3889C54.5854 70.3889 59.0733 68.9244 62.8053 66.1372C63.5612 65.5704 64.317 64.9089 64.9785 64.2476C65.7343 63.4917 66.4901 62.6886 67.1516 61.7911C67.624 61.1769 68.0492 60.5628 68.4271 59.9014C68.6632 59.6179 68.7104 59.2872 68.5687 59.0038Z"
                    fill="#1890FF"
                />
            </g>
            <defs>
                <clipPath id="clip0_678_65350">
                    <rect
                        width="41.6667"
                        height="41.6667"
                        fill="white"
                        transform="translate(29.1666 28.7222)"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    sensitive: (
        <svg
            width={100}
            height={101}
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx={50} cy="50.75" r={50} fill="#FFF4DE" />
            <g clipPath="url(#clip0_678_65397)">
                <path
                    d="M50.0001 41.9995C48.6033 41.9995 47.4663 43.2014 47.4663 44.6781V47.3567H52.5339V44.6781C52.5339 43.2014 51.397 41.9995 50.0001 41.9995Z"
                    fill="#FFA800"
                />
                <path
                    d="M66.2979 28.8701C65.4181 28.4242 64.3765 28.5523 63.6142 29.1984C60.4484 31.8888 54.7498 31.8875 51.5887 29.1998C50.6608 28.4098 49.3395 28.4111 48.4115 29.1984C45.247 31.8888 39.5459 31.8874 36.386 29.1997C35.625 28.5523 34.5799 28.4241 33.7036 28.8701C32.8243 29.3148 32.2638 30.2551 32.2638 31.2858L32.2626 52.7146C32.2626 61.11 38.6292 68.0792 49.2924 71.3582C49.5238 71.4288 49.7613 71.4641 50.0002 71.4641C50.2389 71.4641 50.4766 71.4288 50.708 71.3582C61.3713 68.0792 67.7368 61.1114 67.7368 52.7146V31.2858C67.7368 30.2551 67.1775 29.3148 66.2979 28.8701ZM57.6016 55.3925C57.6016 56.8724 56.4672 58.0711 55.0678 58.0711H44.9325C43.5331 58.0711 42.3987 56.8724 42.3987 55.3925V50.0353C42.3987 48.556 43.5331 47.3567 44.9325 47.3567V44.6781C44.9325 41.7249 47.2053 39.3209 50.0001 39.3209C52.795 39.3209 55.0678 41.7249 55.0678 44.6781V47.3567C56.4672 47.3567 57.6016 48.556 57.6016 50.0353V55.3925Z"
                    fill="#FFA800"
                />
                <path
                    d="M50.0002 51.3746C49.3005 51.3746 48.7333 51.9743 48.7333 52.7139C48.7333 53.4542 49.3005 54.0532 50.0002 54.0532C50.6998 54.0532 51.2671 53.4542 51.2671 52.7139C51.2671 51.9743 50.6998 51.3746 50.0002 51.3746Z"
                    fill="#FFA800"
                />
            </g>
            <defs>
                <clipPath id="clip0_678_65397">
                    <rect
                        width="40.5405"
                        height="42.8571"
                        fill="white"
                        transform="translate(29.7294 28.6069)"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
};
